<script>
import StrCategoryAutocomplete from "@/components/StrCategoryAutocomplete.vue";
import StrPaySectionAutocomplete from "@/components/StrPaySectionAutocomplete.vue";

export default {
    components: {StrPaySectionAutocomplete, StrCategoryAutocomplete},
    props: {
        filter: {
            type: Object,
            required: true
        }
    }
}
</script>

<template>
    <v-row dense>
        <v-col cols="12" md="4">
            <w-text-field
                v-model="filter.code"
                :label="$t('common.code')"
            ></w-text-field>
        </v-col>
        <v-col cols="12" md="4">
            <w-text-field
                v-model="filter.name"
                :label="$t('common.name')"
            ></w-text-field>
        </v-col>
        <v-col cols="12" md="4">
            <w-data-select-autocomplete
                v-model="filter.socioProfessionalId"
                type="SOCIO_PROFESSIONAL"
                :label="$t('data_select.SOCIO_PROFESSIONAL')"
            />
        </v-col>
        <v-col cols="12" md="4">
            <str-category-autocomplete
                v-model="filter.categoryId"
                :label="$t('occupation.category')"
            />
        </v-col>
        <v-col cols="12" md="8">
            <str-pay-section-autocomplete
                v-model="filter.paySectionId"
                :label="$t('module.pay_section')"
                multiple
            />
        </v-col>
    </v-row>
</template>
